import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'

import QueryRendererContainer from '../../components/QueryRendererContainer/QueryRendererContainer'
import Appointment from './Appointment'
import NotFound from './NotFound'

import environment from '../../environments/pom/Environment'
import AppointmentQuery from './queries/Appointment'
import UserContext from '../../helper/userContext'

const Container = () => {
  const { user } = useContext(UserContext)
  const { appointmentId } = useParams()

  const variables = {
    companyId: user.companyId,
    appointmentId,
  }

  return (
    <QueryRendererContainer
      environment={environment(user.accessToken)}
      query={AppointmentQuery}
      variables={variables}
      loading={<Appointment loading />}
      render={(data) => {
        /**
         * @param {{Me:object}} data
         * @param {{Company:object}} data.Me
         * @param {{Appointment:object}} data.Me.Company
         * @param {{usageUnit:array}} data.Me.Company.Appointment
         */
        const appointment = data.Me?.Company?.Appointment

        if (appointment) {
          return <Appointment appointment={appointment} />
        } else {
          return <NotFound />
        }
      }}
    />
  )
}

export default Container
